import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { push } from 'connected-react-router';

import { getAllQueryParamsFromQueryString } from 'utils/urls';
import routes from 'utils/routes';

import UtmCampaign from 'pages/UtmCampaign/styled';

const enhance = compose(
  connect(
    () => ({}),
    (dispatch) => ({
      navigateTo: (path) => dispatch(push(path)),
    })
  ),
  lifecycle({
    componentDidMount() {
      const { location, navigateTo } = this.props;
      const params = getAllQueryParamsFromQueryString(
        (location && location.search) || ''
      );

      try {
        window.localStorage.setItem('utmData', JSON.stringify(params));
      } catch (e) {
        console.log(e);
      } finally {
        navigateTo(routes.orders.active);
      }
    },
  })
);

export default enhance(UtmCampaign);
